module.exports = __webpack_public_path__ + "static/media/gym_03.54f63f6a.svg";